module.exports = __webpack_public_path__ + "images/emoji/100.32873c7eae221cff1ed7.png";